import { del, get, post, put } from '../../api-config';
import { gdpService } from './_service';

export const getMeasuresPatient = async (data: any) =>
  await get(gdpService, `/measures/patient/${data.id}`, null, data.params);
export const getMeasuresPatientsHeatMap = async (data: any) =>
  await get(gdpService, '/measures/patients/heatmap', null, data.params);
export const getMeasure = async (data: any) =>
  await get(gdpService, `/measures/patient/${data.patientId}/measureRaw/${data.measureRawId}`, null, null);

export const retryMeasureIntegration = async (measureId: any) =>
  await post(gdpService, `/measures/admin/${measureId}/integration/retry`);

// Tipos de medida que el grupo del paciente sincroniza vía TSV a nivel dispositivo (con herencia).
// La ficha lo usa para el mensaje informativo: esa subida no tiene confirmación ni la tendrá.
export const getPatientTsvMeasureTypes = async (patientId: any) =>
  await get(gdpService, `/patients/${patientId}/tsv-measure-types`, null, null);

export const getPatientMeasures = async (id: any, params: any) =>
  await get(gdpService, `/patients/${id}/measures`, null, params);
// Configuración de visualización de medidas resuelta para el grupo del paciente.
export const getPatientMeasureViewConfig = async (id: any) =>
  await get(gdpService, `/patients/${id}/measures/view-config`, null, null);
export const getPatientMeasuresGrouped = async (id: any, params: any) =>
  await get(gdpService, `/patients/${id}/measures/grouped`, null, params);
export const getPatientMeasuresDate = async (id: any, params: any) =>
  await get(gdpService, `/measures/patient/${id}/`, null, params);
export const getPatientMeasuresDateGrouped = async (id: any, params: any) =>
  await get(gdpService, `/measures/patient/${id}/grouped`, null, params);

export const postPatientAddMeasure = (data: any) =>
  post(gdpService, `/patients/${data.patientId}/measures`, data, null);

export const getPatientMeasuresByType = (patientId: any, genericTypeId: any, params: any) =>
  get(gdpService, `/measures/patient/${patientId}/type/${genericTypeId}`, null, params);
// Reglas efectivas (paciente > grupo propio > ancestros) ya resueltas por gdp-api.
export const getPatientEffectiveMeasureRules = (patientId: any) =>
  get(gdpService, `/patients/${patientId}/measures/effectiveRules`, null, null);
export const postMeasureNote = (referenceId: any, data: any) =>
  post(gdpService, `/measures/${referenceId}/notes`, data, null);


// reports
export const postReport = (data: any) => post(gdpService, '/reports/measures', data, null);

// Acumulados: cómo cuenta cada uno (config propia y efectiva con herencia) y las reglas que lo activan.
// owner = 'groups' | 'patients'.
export type AccumulationOwner = 'groups' | 'patients';
export const getMeasureAccumulation = (owner: AccumulationOwner, ownerId: string) =>
  get(gdpService, `/measures/accumulation/${owner}/${ownerId}`, null, null);
export const putMeasureAccumulation = (owner: AccumulationOwner, ownerId: string, typeId: number, data: object) =>
  put(gdpService, `/measures/accumulation/${owner}/${ownerId}/${typeId}`, data, null);
export const deleteMeasureAccumulation = (owner: AccumulationOwner, ownerId: string, typeId: number) =>
  del(gdpService, `/measures/accumulation/${owner}/${ownerId}/${typeId}`);
